<template>
 <div class="sidebar-logo-container" :class="{'collapse':collapse}" :style="imgsrc?'height: 150px;':'height: 50px;'">
    <transition name="sidebarLogoFade">
      <!-- <div v-if="collapse" class="small-logo-box">
        <img src="../../../assets/img/lg.png" class="sidebar-logo" />
      </div>
      <div v-else class="logo-box">
        <img src="../../../assets/img/logo.png" class="sidebar-logo" />
      </div> -->
	  <div v-if="imgsrc">
		  <div class="logo-box-two" v-if="collapse">
		    <img :src="imgsrc" class="sidebar-logo" />
		  </div>
		  <div class="small-logo-box-two" v-else>
		    <img :src="imgsrc" class="sidebar-logo" />
		  </div>
	  </div>
	  <div v-else>
		 <div v-if="collapse" class="small-logo-box">
		   <img src="../../../assets/img/lg.png" class="sidebar-logo" />
		 </div>
		 <div v-else class="logo-box">
		   <img src="../../../assets/img/logo.png" class="sidebar-logo" />
		 </div>
	  </div>
	  
      <!-- <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img v-if="avatar" :src="avatar" class="sidebar-logo">
        <h1 v-else class="sidebar-title">{{ name }} </h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="avatar" :src="avatar" class="sidebar-logo">
        <h1 class="sidebar-title">{{ name }} </h1>
      </router-link> -->
    </transition>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
		imgsrc: ''
	}
  },
  created() {
    this.getImg()
  },
  computed: {
    ...mapGetters([
      'name',
      'avatar'
    ])
  },
  methods: {
    async getImg() {
  	  const res = await this.$api.post('/admin/org/getQuotation')
      this.imgsrc = res.data.company_logo
      Cookies.set('site',res.data.site)
      
console.log(Cookies.get('site'));

    },
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  //height: 150px;
  line-height: 50px;
  // background: #EF6027;
  background: #002242;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
.logo-box {
  width: 100%;
  height: 50px;
  padding: 8px 30px;
  img {
    width: 100%;
    height: 100%;
  }
}
.logo-box-two {
  width: 100%;
  height: 50px;
  img {
    width: 100%;
    height: 100%;
  }
}
.small-logo-box {
  width: 100%;
  height: 50px;
  padding: 8px 10px;
  img {
    width: 100%;
    height: 100%;
  }
}
.small-logo-box-two {
  width: 150px;
  height: 150px;
  margin-left: 30px;
  //padding: 8px 10px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
